import tim from '../../tim.js'
import {
    companyDetail, imUserInfoApi,
    jobfairInfoApi,
    jobsDetail,
    resumeDetail,sendOfflineMes,
    talkEnd,
    userinfo,
    userInfoApi
} from '@/api/common'
import { Toast } from 'vant'
const common = {
    namespaced: true,
    state: {
        apiIsLogin:false,//是否登录
        jobfairInfo:{},//招聘会信息
        userInfo:{},//用户接口信息
        imUserInfo:{},//IM用户信息
        toUserData:{},//对方用户信息
        resumeData:{},//简历详情
        jobsData:{},//职位详情
        companyData:{},//企业详情
    },
    getters: {

    },
    mutations: {
        setToUserData(state, data) {
            state.toUserData = data
        },
        //更新招聘会信息包含个人企业列表
        update_jobfair_info(state, data) {
            state.jobfairInfo = data
        },
        //更新用户基本信息
        update_api_user_info(state, data){
            state.userInfo = data
        },
        //更新公司在线状态
        update_company_live(state, data) {
            if (state.jobfairInfo.jobfairCom){
                state.jobfairInfo.jobfairCom.map(item => {
                    let flag = false
                    data.map(company_id => {
                        if (item.company_id == company_id) {
                            flag = true
                        }
                    })
                    flag ? item.online = 1 : item.online = 0;
                })
            }
        },
        //更新个人在线状态
        update_person_live(state, data) {
            if (state.jobfairInfo.perList){
                state.jobfairInfo.perList.map(item => {
                    let flag = false
                    data.map(uid => {
                        if (item.uid == uid) {
                            flag = true
                        }
                    })
                    flag ? item.online = 1 : item.online = 0;
                })
            }
        },
        //更新用户im信息
        update_im_user_info(state, data) {
            state.imUserInfo = data
        }
    },
    actions:{
        //获取招聘会信息
        async getJobfairInfo({commit},id) {
            try {
                const res = await jobfairInfoApi(id)
                commit('update_jobfair_info',res.data)
            }catch (e) {
                throw new Error('获取招聘会详情失败')
            }
        },
        //获取用户基本信息
        async getUserInfo({commit},id) {
            try {
                const res = await userInfoApi(id)
                commit('update_api_user_info',res.data)
                return res
            }catch (e) {
                throw new Error('获取用户详情失败')
            }
        },
        //获取用户im信息
        async getImUserInfo({commit},param) {
            try {
                const res = await imUserInfoApi(param.userId,param.jobfairId)
                commit('update_im_user_info',res.data)
                return res
            }catch (e) {
                throw new Error('获取用户Im详情失败')
            }
        },
        resumeDetail(context,data) {
            return new Promise((resolve) => {
                resumeDetail(data.resumeId,data.is_temp).then(res => {
                    if (res.status===200) {
                        context.state.resumeData=res.data
                    }else{
                        Toast.fail('获取简历详情失败！')
                        context.state.resumeData={}
                    }
                    resolve()
                })
            })
        },
        jobsDetail(context,data) {
            return new Promise((resolve) => {
                jobsDetail(data.jobsId,data.is_temp).then(res => {
                    if (res.status===200) {
                        context.state.jobsData=res.data
                    }else{
                        Toast.fail('获取职位详情失败！')
                        context.state.jobsData={}
                    }
                    resolve()
                })
            })
        },
        companyDetail(context,companyId) {
            return new Promise((resolve) => {
                companyDetail(companyId).then(res => {
                    if (res.status===200) {
                        context.state.companyData=res.data
                    }else{
                        Toast.fail('获取职位详情失败！')
                        context.state.companyData={}
                    }
                    resolve()
                })
            })
        },
        //获取洽谈对方信息
        async chatUserInfo(context,param) {
            try {
                const res = await userinfo(param.toUserId,param.userId)
                context.commit('setToUserData',res.data)
            }catch (e) {
                throw new Error('获取对方用户详情失败')
            }
        },
        //结束洽谈
        async endTalk(context,param) {
            try {
                const res = await talkEnd(param.userId, param.toUserId, param.talk_id, param.evaluate_id, param.evaluate_status)
                tim.deleteConversation('C2C'+param.toUserId)
                  .then(() => {
                      return res
                  })
            }catch (e) {
                throw new Error('结束洽谈失败')
            }
        },
        sendOfflineMes(context,param){
            return new Promise((resolve) => {
                sendOfflineMes(
                    param.jobfair_id,
                    param.userId,
                    param.toUserId,
                    param.userType,
                    param.msg
                ).then(res => {
                    if (res.status===200) {
                        Toast('留言成功');
                    }else{
                        Toast.fail(res.message)
                    }
                    resolve()
                })
            })
        }
    }
}

export default common
